import { render, staticRenderFns } from "./collection-point-design.vue?vue&type=template&id=fa512202&"
import script from "./collection-point-design.vue?vue&type=script&lang=js&"
export * from "./collection-point-design.vue?vue&type=script&lang=js&"
import style0 from "./collection-point-design.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports